import { render, staticRenderFns } from "./QuickLinksCategory.vue?vue&type=template&id=082e9d34&scoped=true&"
import script from "./QuickLinksCategory.vue?vue&type=script&lang=js&"
export * from "./QuickLinksCategory.vue?vue&type=script&lang=js&"
import style0 from "./QuickLinksCategory.vue?vue&type=style&index=0&id=082e9d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082e9d34",
  null
  
)

export default component.exports